import React from 'react';
import { ChevronRight } from 'lucide-react';

const ChildServices = () => {
  const childServices = [
    {
      id: 1,
      title: "Individual Play Therapy",
      image: "/static/img/service-images/19.webp"
    },
    {
      id: 2,
      title: "Speech Therapy",
      image: "/static/img/service-images/7.webp"
    },
    {
      id: 3,
      title: "Occupational Therapy",
      image: "/static/img/service-images/21.webp"
    },
    {
      id: 4,
      title: "Special Education",
      image: "/static/img/service-images/22.webp"
    },
    {
      id: 5,
      title: "Group Therapy",
      image: "/static/img/service-images/23.webp"
    },
    {
      id: 6,
      title: "Psychological Testing",
      image: "/static/img/service-images/25.webp"
    },
    {
      id: 7,
      title: "Teen-Sensitive Services",
      image: "/static/img/service-images/26.webp"
    },
    {
      id: 8,
      title: "Outreach To Families Affected By Trauma",
      image: "/static/img/service-images/27.webp"
    },
    {
      id: 9,
      title: "Crisis Intervention And Brief Therapy",
      image: "/static/img/service-images/28.webp"
    },
    {
      id: 10,
      title: "Eating Disorder Evaluation And Treatment",
      image: "/static/img/service-images/29.webp"
    },
    {
      id: 11,
      title: "Consultation For Child Care And Primary Caregivers",
      image: "/static/img/service-images/30.webp"
    },
    {
      id: 12,
      title: "Assessment Program",
      image: "/static/img/service-images/31.webp"
    },
    {
      id: 13,
      title: "Infant-Parent Programs",
      image: "/static/img/service-images/32.webp"
    },
    {
      id: 14,
      title: "Information And Referrals",
      image: "/static/img/service-images/33.webp"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <section className="relative overflow-hidden bg-gradient-to-br from-primary-800 via-primary-700 to-primary-600 text-white py-20 lg:py-24">
        <div className="absolute -top-24 left-10 h-72 w-72 rounded-full bg-white/10 blur-3xl"></div>
        <div className="absolute bottom-0 right-0 h-80 w-80 rounded-full bg-white/10 blur-3xl"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="relative text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-semibold leading-tight mb-6">
              Child & Adolescent Services
            </h1>
            <p className="text-lg text-white/80 max-w-3xl mx-auto">
              Compassionate mental health care designed specifically for children and teenagers
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {childServices.map((service) => (
              <div key={service.id} className="relative rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow group">
                {/* Background Image */}
                <div 
                  className="absolute inset-0 bg-cover bg-center"
                  style={{ backgroundImage: `url(${service.image})` }}
                />
                {/* Dark Overlay for text readability */}
                <div className="absolute inset-0 bg-black bg-opacity-40 group-hover:bg-opacity-50 transition-opacity" />
                
                {/* Content */}
                <div className="relative p-6 h-64 flex flex-col justify-end">
                  <h3 className="text-xl font-bold text-white mb-4">
                    {service.title}
                  </h3>
                  
                  <button className="bg-primary-600 text-white py-2 px-4 rounded-lg font-medium hover:bg-primary-700 transition-colors flex items-center justify-center space-x-2 self-start">
                    <span>Learn More</span>
                    {ChevronRight && <ChevronRight className="w-4 h-4" />}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ChildServices;
